import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Divider, Caption1 } from '@fluentui/react-components';
import { Carousel, SimpleCarousel } from '@bingads-webui-campaign-react/carousel';

import { Status } from '@bingads-webui-campaign-react/status-popover';
import { ActionCard } from './action-card';
import { useStyles } from '../../styles/action-cards-styles';

export function ActionCards({
  details,
  i18n,
  isSmallScreen,
}) {
  const classes = useStyles();

  const contents = details.map(item => <ActionCard key={item.name} {...item} i18n={i18n} />);

  return (
    <div className={classNames('ba-diagnostic-action-cards-container')}>
      <Divider inset className={classNames('ba-diagnostic-divider', classes.divider)} />
      <Caption1 block className={classNames('ba-diagnostic-cards-message', classes.cardsMessage)}>
        {i18n.getString(_TL_('Improve your campaign setup ({{count}})'), { count: details.length })}
      </Caption1>
      <div className={classNames('ba-diagnostic-action-cards-list', classes.actionCardsList)}>
        {/* contentWidth is cardWidth + margin */}
        {isSmallScreen ? <SimpleCarousel contents={contents} /> : <Carousel contents={contents} contentWidth={372} i18n={i18n} />}
      </div>
    </div>
  );
}

ActionCards.propTypes = {
  details: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(Status)).isRequired,
    cardTitle: PropTypes.string,
    cardMsg: PropTypes.string,
    onCardButtonClicked: PropTypes.func,
    cardButtonText: PropTypes.string,
  })).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  isSmallScreen: PropTypes.bool,
};

ActionCards.defaultProps = {
  isSmallScreen: false,
};
